import {
  LEARNING_SEQUENCE_CONCLUSION_CATEGORIES,
  LEARNING_SEQUENCE_INTRODUCTION_CATEGORIES,
  LEARNING_SEQUENCE_QUESTION_CATEGORIES,
} from 'global/constants';
import { OutcomesFragment } from '../graphql/outcomes/__generated__/OutcomesFragment';
import {
  LessonTeachingLearningSequenceFragment_teachingAndLearningSequence,
  LessonTeachingLearningSequenceFragment_teachingAndLearningSequence_connections,
} from 'approot/lesson/sections/teaching-learning-sequence/__generated__/LessonTeachingLearningSequenceFragment';
import { GetLessonTeachingAndLearningSequence_getLessonTeachingAndLearningSequence } from 'approot/activity-builder/components/teaching-notes/__generated__/GetLessonTeachingAndLearningSequence';

export const MAX_SEQUENCE_QUESTIONS = 100;

export type TeachingAndLearningOutcome = OutcomesFragment & {
  description: string;
  type: string | null;
};

export type TeachingAndLearningCategoryOptions =
  | typeof LEARNING_SEQUENCE_INTRODUCTION_CATEGORIES
  | typeof LEARNING_SEQUENCE_QUESTION_CATEGORIES
  | typeof LEARNING_SEQUENCE_CONCLUSION_CATEGORIES;

export type TeachingLearningConnections = LessonTeachingLearningSequenceFragment_teachingAndLearningSequence_connections;

export const ENGLISH_CONNECTION = 'ELA Connections';
export const MATH_CONNECTION = 'Math Connections';

export type TeachingAndLearningSequence =
  | LessonTeachingLearningSequenceFragment_teachingAndLearningSequence
  | GetLessonTeachingAndLearningSequence_getLessonTeachingAndLearningSequence;
